var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4167 1.91675V7.75008C16.4167 8.52363 16.724 9.26549 17.2709 9.81248C17.8179 10.3595 18.5598 10.6667 19.3333 10.6667H25.1667M7.66668 17.9584H10.5833M16.4167 17.9584H19.3333M7.66668 23.7917H10.5833M16.4167 23.7917H19.3333M17.875 1.91675H4.75001C3.97646 1.91675 3.2346 2.22404 2.68762 2.77102C2.14063 3.318 1.83334 4.05987 1.83334 4.83341V28.1667C1.83334 28.9403 2.14063 29.6822 2.68762 30.2291C3.2346 30.7761 3.97646 31.0834 4.75001 31.0834H22.25C23.0236 31.0834 23.7654 30.7761 24.3124 30.2291C24.8594 29.6822 25.1667 28.9403 25.1667 28.1667V9.20841L17.875 1.91675Z",
    stroke: "#0071E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/vector-4.cc8703fd10db326635f435eb174de342.svg";
export { ForwardRef as ReactComponent };